import { ControlGroup } from "@blueprintjs/core"
import React, { useEffect, useState, useMemo } from "react"
import { useSelector } from "react-redux"
import StringInput from "components/Atoms/StringInput"
import DynamicSelector from "components/Molecules/DynamicSelector"
import { DEPOTS, SKUS } from "graphql/selector.queries.gql"
// import { getId } from "utils/custom.utils";
import PlotCommoditySearch from "../../scheduling-new/header/PlotCommoditySearch"
import AddScheduleMutation from "./AddScheduleMutation"
export default function AddSchedule({ uuid, bookings }) {
  const requiredQty = useMemo(() => {
    // Get the requiredQuantity by subtracting total required - total procured
    // If the operation results in undefined, null or NaN then return 0
    return (
      bookings?.reduce((prev, booking) => {
        return prev + booking.requiredQuantity - booking?.procuredQuantity
      }, 0) || 0
    )
  }, [bookings])

  const selectedPlot = useSelector(state => state.vehicle.plotCommodity)

  const [query, changeQuery] = useState("")
  const [plotCommodity, changePlotCommodity] = useState({})
  const [scheduleState, setSchedule] = useState({
    requiredQuantity: requiredQty ?? 0,
    destinationDepot: null,
    sourceDepot: null,
  })

  useEffect(() => {
    changePlotCommodity(selectedPlot)
    setSchedule({
      skuType: selectedPlot?.variety?.preferredSku,
      requiredQuantity: requiredQty,
    })
  }, [changePlotCommodity, setSchedule, selectedPlot, requiredQty])
  function handleQueryChange(query) {
    if (query.length > 2 || query.length === 0) changeQuery(query)
  }

  function handleChange(path, value) {
    setSchedule(prev => ({
      ...prev,
      [path]: value,
    }))
  }
  return (
    <>
      <PlotCommoditySearch
        fill={false}
        query={query}
        className="my-0"
        onQueryChange={handleQueryChange}
        selectedItem={plotCommodity}
        onSelect={item => {
          changePlotCommodity(item)
          changeQuery("")
        }}
      />
      <ControlGroup fill className="ml-3">
        <DynamicSelector
          className="mb-0"
          label="SKU Type"
          query={SKUS}
          path="skuType"
          onChange={handleChange}
          value={scheduleState?.skuType}
          variables={{
            filter: {
              metadata_Labels_Contains: ["vesatogo"],
            },
          }}
        />
        <StringInput
          fill
          className="mb-0"
          label="Quantity"
          big={false}
          path="requiredQuantity"
          onChange={handleChange}
          value={scheduleState?.requiredQuantity}
        />
      </ControlGroup>
      <DynamicSelector
        query={DEPOTS}
        className="ml-3 mb-0"
        label="Source"
        path="sourceDepot"
        value={scheduleState?.sourceDepot}
        onChange={handleChange}
      />
      <DynamicSelector
        className="ml-3 mb-0"
        label="Destination"
        path="destinationDepot"
        query={DEPOTS}
        value={scheduleState?.destinationDepot}
        onChange={handleChange}
      />
      <AddScheduleMutation
        className="ml-3"
        dark
        icon="plus"
        text="Schedule"
        onChange={handleChange}
        skuType={scheduleState?.skuType?.id}
        plotCommodityId={plotCommodity?.id}
        requiredQuantity={scheduleState?.requiredQuantity}
        sourceDepot={scheduleState?.sourceDepot?.id}
        destinationDepot={scheduleState?.destinationDepot?.id}
        tripUuid={uuid}
        onCompleted={data => {
          changePlotCommodity({})
          setSchedule({})
        }}
      />
    </>
  )
}
